const updateLiveConsult = async () => {
  const user = sessionStorage.getItem("user");
  if (![undefined, "undefined", null, "null", ""].includes(user)) {
    const parsedUser = JSON.parse(user);
    const payload = {
      userId: parsedUser.username,
      is_live: false,
    };
    return await fetch(process.env.REACT_APP_BASEURL + `updateIsLive`, {
      method: "PUT",
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((response) => {
        return response;
      });
  }
};

export default updateLiveConsult;


// WEBPACK FOOTER //
// ./src/components/common/apis.js